import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useResources() {
  const [loading, setLoading] = useState(true);
  const [resources, setResources] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.resources.index)
      .then((response) => {
        setResources(response.data.data);
        setLoading(false);
      });
  }, []);

  return { loading, resources };
}
